import { Helmet } from "react-helmet";

export const Header = () => {
    return (
        <Helmet>
            <meta charSet="UTF-8" />

            <link rel="icon" type="image/svg+xml" href="/favicon-32.png" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />

            <link rel="stylesheet" href="https://cdn.jsdelivr.net/gh/lipis/flag-icons@6.6.6/css/flag-icons.min.css" />

            <title>Testuj.to - Client</title>
            <meta name="description" content="Testuj.to - Client" />

            <script src="https://js.stripe.com/v3/"></script>

            {/*<!-- Google Tag Manager --> */}
            {import.meta.env.VITE_ENV === "prod" && (
                <script>
                    {`
                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','GTM-PZB6VPG2');
                `}
                </script>
            )}
            {/*<!-- End Google Tag Manager -->*/}
        </Helmet>
    );
};
